// src/pages/FreeHomeDelivery.js
import React from 'react';
import { Container } from 'react-bootstrap';
import Service from '../components/Service';
const Services= () => {
  return (
<Service/>
  );
};

export default Services;
